export default __webpack_public_path__ + "static/media/articulated_dump_truck.e2ce33c4.jpg";